import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function descuentoComboReducer(state= initialState.descuentoCombo, action){
	switch(action.type){
		case types.GET_DESCUENTOS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}